/*
 * @创建文件时间: 2019-10-29 15:53:49
 * @最后修改人        : lfq
 * @最后修改时间       : 2020-01-03 15:51:16
 * @联系Qq:1638245306
 * @文件介绍: 关于用户的设置
 */
export default {
    namespaced: true,
    state: {
        // 用户信息
        info: {},
        authorities: ['123']
    },
    actions: {
        /**
         * @description 设置用户数据
         * @param {Object} context
         * @param {*} info info
         */
        set({ state, dispatch }, info) {
            return new Promise(async resolve => {
                // store 赋值
                state.info = info
                    // 持久化
                await dispatch('d2admin/db/set', {
                        dbName: 'sys',
                        path: 'user.info',
                        value: info,
                        user: true
                    }, { root: true })
                    // end
                resolve()
            })
        },
        /**
         * @description 从数据库取用户数据
         * @param {Object} context
         */
        load({ state, dispatch }) {
            return new Promise(async resolve => {
                // store 赋值
                state.info = await dispatch('d2admin/db/get', {
                        dbName: 'sys',
                        path: 'user.info',
                        defaultValue: {},
                        user: true
                    }, { root: true })
                    // end
                resolve(state.info.userData)
            })
        }
    },
    getters: {
        //获取权限按钮
        getAuthorities: (state) => {
            return state.authorities
        }
    },
    mutations: {
        //设置权限按钮
        SET_AUTHORITIES(state, authorities) {
            state.authorities = authorities
        }
    }
}